import React, {useState} from 'react';
import '../../Styles/Dashboard.scss';
import { PieChart, Pie, Sector, ResponsiveContainer,Cell } from "recharts";
import { useTheme } from '@material-ui/core/styles';
import Dashboard__ChartLegend from './Dashboard__ChartLegend';

export default function Dashboard__PieChart(props) {

    const [activeIndex, setActiveIndex] = useState(0);
    const theme = useTheme();

    const data = [
        { name: "DRINKS", value: 400 },
        { name: "COLD STARTERS", value: 300 },
        { name: "DESERTS", value: 300 },
        { name: "GRILLS", value: 200 }
      ];
    
      const onPieEnter = (data, index) => {
            setActiveIndex(index);
      };
      //const COLORS = [theme.palette.primary.main, theme.palette.primary.light, theme.palette.primary.light, theme.palette.primary.light];
      const COLORS = [ '#5dbcd2','#82cc60', '#979797', '#ff8447'];

    return (
        <React.Fragment>
            <div className="dashboard__chart-wrapper">
                <div className="dashboard__chart-title">Most Popular Categories:</div>
                <Dashboard__ChartLegend></Dashboard__ChartLegend>
            <ResponsiveContainer width="100%" height={200}>
            
            <PieChart width={320} height={320}>
        <Pie
          activeIndex={activeIndex}
          activeShape={renderActiveShape}
          data={data}
          cx={'50%'}
          cy={100}
          innerRadius={70}
          outerRadius={90}
          fill="#9faf30"
          dataKey="value"
          onMouseEnter={onPieEnter}
        >
             {
            data.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />)
          }
        </Pie>
      </PieChart>
      </ResponsiveContainer>
      </div>
        </React.Fragment>
    );
}


  
  const renderActiveShape = props => {
    const RADIAN = Math.PI / 180;
    const {
      cx,
      cy,
      midAngle,
      innerRadius,
      outerRadius,
      startAngle,
      endAngle,
      fill,
      payload,
      percent,
      value
    } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + 10) * cos;
    const sy = cy + (outerRadius + 10) * sin;
    const mx = cx + (outerRadius + 30) * cos;
    const my = cy + (outerRadius + 30) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 22;
    const ey = my;
    const textAnchor = cos >= 0 ? "start" : "end";
  
    return (
      <g>
        <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
          {payload.name}
        </text>
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={fill}
        />
        <Sector
          cx={cx}
          cy={cy}
          startAngle={startAngle}
          endAngle={endAngle}
          innerRadius={outerRadius + 6}
          outerRadius={outerRadius + 10}
          fill={fill}
        />
       
        
       
      </g>
    );
  };
  